import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import {
    alcoholEenhedenPerWeekSchema,
    bloeddrukDiastolischSchema,
    bloeddrukSystolischSchema,
    buikomvangSchema,
    gewichtInKgSchema,
    lengteInCmSchema,
    polsInBpmSchema,
} from '@common/validation/schemas';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextAreaConditionalSchema } from '@common/validation/utils/getTextAreaConditionalSchema';
import type { BariPreSecretarialAssistantMedScreeningReportBaseData } from './bariPreSecretarialAssistantMedScreeningReportData';

export const bariPreSecretarialAssistantMedScreeningReportBaseFinal: TypedSchema<BariPreSecretarialAssistantMedScreeningReportBaseData> =
    {
        alcohol: Koi.boolean().allow(null),
        alcohol_aantal_eenheden_per_week: Koi.when('alcohol', {
            is: true,
            otherwise: Koi.valid(null),
            then: alcoholEenhedenPerWeekSchema.allow(null),
        }),
        alcohol_toelichting: getTextAreaConditionalSchema('alcohol', true),
        bloeddruk_diastolisch: Koi.when('bloeddruk_gemeten', {
            is: true,
            otherwise: Koi.valid(null),
            then: bloeddrukDiastolischSchema,
        }),
        bloeddruk_gemeten: Koi.boolean(),
        bloeddruk_systolisch: Koi.when('bloeddruk_gemeten', {
            is: true,
            otherwise: Koi.valid(null),
            then: bloeddrukSystolischSchema,
        }),
        buikomvang: buikomvangSchema,
        datum_screening: Koi.koi().todayOrBefore(),
        drugs: Koi.boolean().allow(null),
        drugs_toelichting: getTextAreaConditionalSchema('drugs', true),
        gewicht_in_kg: gewichtInKgSchema,
        hoogste_gewicht_in_kg: gewichtInKgSchema,
        lengte_in_cm: lengteInCmSchema,
        pols: polsInBpmSchema,
        saturatie: Koi.number().min(0).max(100).allow(null),
    };

export const bariPreSecretarialAssistantMedScreeningReportBaseDraft: TypedSchema<BariPreSecretarialAssistantMedScreeningReportBaseData> =
    addAllowNull(bariPreSecretarialAssistantMedScreeningReportBaseFinal);
